import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "../Slide/SlideDeleteValidator.scss";
import "../../css/Popup.scss";
import { keycloak } from "../../services/keycloak";

const LogInModal = ({ register }) => {
    const [sessionExpiredPopup, setSessionExpiredPopup] = useState(false)
    
    useEffect(() => {
        register(() => setSessionExpiredPopup)
    }, []);

    const handleLogout = async () => {
        setSessionExpiredPopup(false)
        try {
            await keycloak.logout({
                redirectUri: window.location.origin
            });
        } catch (e) {
            console.error("Logout failed", e);
        }
    };
    
    return (
        <div className="deletePromptParent">
            <Dialog
                open={sessionExpiredPopup}
                // onClose={handleLogout}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="deletePrompt confirmation"
                sx={{
                    backdropFilter: "blur(2.4px)",
                }}
            >
                <DialogContent style={{ overflowY: "initial", width: "380px", height: "160px" }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        className="discription"
                    >
                        <div className="popup-head">SESSION TIME OUT</div>
                        <div className="popup-separator"></div>
                        <div className="popup-message"><span style={{ color: "#C50F3C" }}>Your session has expired.</span> All changes have been saved. Please log in again to continue working.</div>
                    </DialogContentText>
                </DialogContent>
                <div style={{display: "flex", justifyContent: "end"}} className="popupFooter">
                    <Button
                        className="btn popupFooterActiveButton"
                        type="button"
                        onClick={handleLogout}
                    >
                        LOGIN
                    </Button>
                </div>
            </Dialog>
        </div>
    );
};

export default LogInModal;